/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptTeamInviteBody
 */
export interface AcceptTeamInviteBody {
    /**
     * The UUID invite code from the invitation email or link
     * @type {string}
     * @memberof AcceptTeamInviteBody
     */
    inviteCode: string;
}

/**
 * Check if a given object implements the AcceptTeamInviteBody interface.
 */
export function instanceOfAcceptTeamInviteBody(value: object): value is AcceptTeamInviteBody {
    if (!('inviteCode' in value) || value['inviteCode'] === undefined) return false;
    return true;
}

export function AcceptTeamInviteBodyFromJSON(json: any): AcceptTeamInviteBody {
    return AcceptTeamInviteBodyFromJSONTyped(json, false);
}

export function AcceptTeamInviteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptTeamInviteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteCode': json['inviteCode'],
    };
}

export function AcceptTeamInviteBodyToJSON(json: any): AcceptTeamInviteBody {
    return AcceptTeamInviteBodyToJSONTyped(json, false);
}

export function AcceptTeamInviteBodyToJSONTyped(value?: AcceptTeamInviteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inviteCode': value['inviteCode'],
    };
}

